import { useQuery } from '@tanstack/react-query';
import { serviceDesksApi, ServiceDeskOption } from '../api/serviceDesksApi';

export const serviceDesksQueryKey = ['service-desks', 'all'];

export const useServiceDesks = (options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;

  const { data, isLoading, error, refetch } = useQuery<ServiceDeskOption[]>({
    queryKey: serviceDesksQueryKey,
    queryFn: () => serviceDesksApi.list(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    serviceDesks: data ?? [],
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
